const SKIP = Symbol('skip');

type ElementDef = {
    type: string;
    schema?: Record<string, ElementDef>;
    default?: any;
    [key: string]: any;
};

function defaultForElement(def: ElementDef): any {
    if ('default' in def && def.default !== undefined) {
        return JSON.parse(JSON.stringify(def.default));
    }

    switch (def.type) {
        case 'text':
        case 'textarea':
        case 'postcode-lookup':
            return '';

        case 'select':
        case 'radiogroup':
        case 'date':
        case 'money':
            return null;

        case 'multi-select':
        case 'checkboxgroup':
            return [];

        case 'checkbox':
            return false;

        case 'list':
            return [];

        case 'object':
        case 'group': {
            if (!def.schema) return {};
            const inner: Record<string, any> = {};
            for (const [key, child] of Object.entries(def.schema)) {
                if (!child || typeof child !== 'object' || !child.type) continue;
                const val = defaultForElement(child);
                if (val !== SKIP) inner[key] = val;
            }
            return inner;
        }

        case 'static':
        case 'button':
            return SKIP;

        default:
            return null;
    }
}

/**
 * Generate an empty form data model from a grouped Vueform schema.
 *
 * Top-level keys (e.g. riskQuestions, coverDetails) are grouping containers
 * whose children are Vueform element definitions with a `type` property.
 */
export function generateEmptyModel(schema: Record<string, any>): Record<string, any> {
    const result: Record<string, any> = {};

    for (const [groupKey, groupValue] of Object.entries(schema)) {
        if (!groupValue || typeof groupValue !== 'object') continue;

        const group: Record<string, any> = {};
        for (const [childKey, childValue] of Object.entries(groupValue)) {
            if (!childValue || typeof childValue !== 'object' || typeof (childValue as any).type !== 'string') continue;
            const val = defaultForElement(childValue as ElementDef);
            if (val !== SKIP) group[childKey] = val;
        }
        result[groupKey] = group;
    }

    return result;
}
